import React from 'react'

import { Button } from 'src/components/Button/Button'
import { ErrorSign, H1, PMedium } from 'src/styles/commons'
import { Icons } from 'src/utils/icons'
import { useTheme } from 'styled-components'

import { BtnBack, Container, Content, ErrorContainer } from './ErrorPage.styles'

interface IErrorPage {
  title: string | JSX.Element
  subTitle: string | JSX.Element
  nameButton?: string
  disabledButton?: boolean
  disabledHome?: boolean
  goHome: () => void
  done: () => void
  comeBackLater: () => void
}

export function ErrorPage({
  title,
  subTitle,
  nameButton,
  disabledButton,
  disabledHome,
  goHome,
  done,
  comeBackLater,
}: IErrorPage) {
  const theme = useTheme()

  const errorIcon = <Icons.Canceled width={32} height={32} color={theme.colors.base.white} />
  const homeIcon = <Icons.Home width={24} height={24} color={theme.colors.primary.A500} />

  const tryAgainButton = (
    <Button className="foot-button" data-testid="done-button" onClick={done}>
      {nameButton || 'Tente novamente'}
    </Button>
  )

  const comeBackLaterButton = (
    <Button
      className="foot-second-button"
      variant="secondary"
      data-testid="come-later-button"
      onClick={comeBackLater}
    >
      Voltar mais tarde
    </Button>
  )

  return (
    <ErrorContainer>
      <Container>
        <BtnBack
          type="button"
          onClick={goHome}
          aria-label="Botão voltar erro"
          data-testid="home-button"
        >
          {!disabledHome && homeIcon}
        </BtnBack>
        <Content>
          <ErrorSign>{errorIcon}</ErrorSign>
          <H1 margin="24px 0 8px">{title || 'Houve um erro por aqui'}</H1>
          <PMedium scale={400}>{subTitle}</PMedium>
        </Content>
        {!disabledButton && tryAgainButton}
        {!disabledButton && comeBackLaterButton}
      </Container>
    </ErrorContainer>
  )
}
